export default __webpack_public_path__ + "static/media/FeverLand_04.cc123e3f.png";